<template>
  <div class="container">
    <header>
      <button class="button-icon square-icon w3-right" href="#" :title="$t('round.addRound')" v-if="managementFunctions" @click="addRound()"><font-awesome-icon icon="plus-square" class="align-icon"/>  {{ $t('tournaments.round')}}</button>
    </header>

    <transition name="modal-fade" v-if="_showRoundEdit">
      <div class="modal-backdrop">
        <div class="modal">
          <section class="modal-body">
            <slot name="body">
              <add-round :roundId="selectedRound" 
                         :action="_roundAction"
                         v-on:cancel="handleModalResultCancel()" 
                         v-on:ok="handleModalResultOK()" ></add-round>
            </slot>
          </section>
        </div>
      </div>
    </transition>

    <div class="details">
      <div v-if="rounds.length > 0" class="two-column-container">

        <div class="column left">
          <div class="result-line" v-for="round in _leftRounds"
                                  :key="round.roundId" 
                                  :round = "round">          
            
            <div class="item wide">
              {{round.number}}.  <a href="#" @click="$emit('showRound', round.number)">{{showDate(round.date)}}</a>
              <div v-if="userIsParticipant" v-html="showUserResult(round.roundId)"></div>

              <div class="yesno" v-if="userIsParticipant && round.status=='Planned'">Aanwezig: {{round.result}}
                <a class="imgbtn" href="#" title="change presence" @click="changePresence(round.roundId)">
                  <span :class="presentInRound(round.roundId)">ja</span> 
                  <span :class="notPresentInRound(round.roundId)">nee</span>
                </a>
              </div>

              <div v-if="userIsParticipant && round.status!='Planned'">
                {{showAbsenceForRound(round.roundId)}} 
              </div>
            </div> 
            
            <button v-if="managementFunctions" class="grid-btn floatright" href="#" title="edit round" @click="editRound(round.roundId)"><font-awesome-icon icon="edit" class="pushup-two" /></button>
            <button v-if="managementFunctions" class="grid-btn" href="#" title="create pairing" @click="pairRound(round.roundId)"><font-awesome-icon icon="wrench"  class="pushup-two"/></button>
            <button v-if="managementFunctions" class="grid-btn" href="#" title="delete this round" @click="deleteRound(round.roundId)"><font-awesome-icon icon="trash"  class="pushup-one"/></button>
          </div>        
        </div>

        <div class="column right">
          <div class="result-line" v-for="round in _rightRounds"
                                  :key="round.roundId" 
                                  :round = "round">          
            
            <div class="item wide">
              {{round.number}}.  <a href="#" @click="$emit('showRound', round.number)">{{showDate(round.date)}}</a>
              <div v-if="userIsParticipant" v-html="showUserResult(round.roundId)"></div>

              <div class="yesno" v-if="userIsParticipant && round.status=='Planned'">Aanwezig: {{round.result}}
                <a class="imgbtn" href="#" title="change presence" @click="changePresence(round.roundId)">
                  <span :class="presentInRound(round.roundId)">ja</span> 
                  <span :class="notPresentInRound(round.roundId)">nee</span>
                </a>
              </div>

              <div  class="item" v-if="userIsParticipant && round.status!='Planned'">
                {{showAbsenceForRound(round.roundId)}} 
              </div>
            </div> 
            
            <button v-if="managementFunctions" class="grid-btn floatright" href="#" title="edit round" @click="editRound(round.roundId)"><font-awesome-icon icon="edit" class="pushup-two" /></button>
            <button v-if="managementFunctions" class="grid-btn" href="#" title="create pairing" @click="pairRound(round.roundId)"><font-awesome-icon icon="wrench"  class="pushup-two"/></button>
            <button v-if="managementFunctions" class="grid-btn" href="#" title="delete this round" @click="deleteRound(round.roundId)"><font-awesome-icon icon="trash"  class="pushup-one"/></button>
          </div>
        </div>

      </div>
      
      <div v-if="rounds.length==0">{{$t('round.noRounds')}}</div>
    </div>
  </div>
</template>

<script>

import {RestAPI} from "@aws-amplify/api-rest";
import moment from 'moment';
import AddRound from './AddRound.vue';

const apiName = 'api';
const myInit = { 
  response: false, 
};

export default {
  name: 'RoundsList',
  components: {AddRound},
  props: {
    tournamentId: String,
    managementFunctions: Boolean
  },
  emits: ['showRound'],
  data: function() {
    return {
      absentWithMSG: -1,
      absenceScores: [],
      reasons: [{reasonId:"1", name:"absent with message"},
                {reasonId:"2", name:"absent without message"},
                {reasonId:"3", name:"absent for club"},
                {reasonId:"4", name:"manual bye"}],
      roundAction: "edit",
      rounds: [],
      selectedRound: -1,
      showingRoundEdit: false,
      userAbsences: [],
      userIsParticipant: false,
      userParticipantid: -1,
      userResults: []
    }
  },
  beforeMount() {
    this.loadScores();
    this.checkParticipation();
    this.loadRounds();
  },
  computed: {
    _showRoundEdit: function() {
      return this.showingRoundEdit;      
    },

    _roundAction: function() {
      return this.roundAction;
    },
    _leftRounds: function() {
        // 1. calculate the index to split, round up
        const splitIndex = Math.ceil(this.rounds.length / 2); 
        return this.rounds.slice(0, splitIndex);
    },
    _roundsCount: function() {
      return this.rounds.length;
    },
    _rightRounds: function() {
        // 1. calculate the index to split, round up
        const splitIndex = Math.ceil(this.rounds.length / 2); 
        return this.rounds.slice(splitIndex);
    }
  },
  methods: {
    addAbsence(absence) {
      
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: absence,
        response: false, 
      };
      let path = "/absence/";
      RestAPI
        .post(apiName, path, myInit)
        .then(
            console.log("Absence added"))
        .catch(error => {
          console.log(error.response);
        });
    },

    addRound() {
      this.selectedRound = -1;
      this.roundAction = "add";
      this.showingRoundEdit = true;
    },

    changePresence(roundId) {
      var absence = this.userAbsences.find(ua => { 
      if (ua.roundId === roundId) { 
        return ua
      }});

      if (absence != null) {
        if (absence.reasonId == this.absentWithMSG.scoreId) { //reasonId:"1", name:"absent with message"
          this.removeAbsence(absence);
          this.userAbsences.splice(this.userAbsences.indexOf(absence), 1);
        }
      } else {
        var newAbsence = {roundId:-1};
        newAbsence.roundId = roundId ;
        newAbsence.reasonId = this.absentWithMSG.scoreId;
        newAbsence.tournamentId = this.tournamentId;
        newAbsence.participantId = this.userParticipantid;

        console.log("Adding absence: " + JSON.stringify(newAbsence));
        this.addAbsence(newAbsence);
        this.userAbsences = this.userAbsences.concat([newAbsence]);
      }
    },

    checkParticipation() {
      if (this.$CAUser.loggedIn() == true) {
        console.log("Participation check");
        let that = this;
        let path = '/participant?tournamentId=' + this.tournamentId + '&personId=' + this.$CAUser.getPersonId();
        RestAPI
          .get(apiName, path, myInit)
          .then(response => {
            var participants = response;
            that.userIsParticipant = (participants.length == 1);
            if (that.userIsParticipant) {
              that.userParticipantid = participants[0].participantId;
              console.log('setting participantID: ' + that.userParticipantid);
              that.loadUserResults();
              that.loadUserAbsences();
            }
            console.log("userIsParticipant: " + JSON.stringify(response));
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    },

    deleteRound: function(roundId) {
      let path = '/round/' + roundId;
      let that = this;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false, 
      };
      console.log('Deleting round: ' + roundId);
      RestAPI
        .del(apiName, path, localInit)
        .then(response => {
          console.log('Succes.' + response);
          that.loadRounds();
        })
        .catch(error => {
          console.log(error.response);
        });
        
      console.log('Round deleted.');
    },

    editRound(roundId) {
      this.selectedRound = roundId;
      this.roundAction = "edit";
      this.showingRoundEdit = true;
    },

    handleModalResultCancel() {
      console.log('Action cancelled');
      this.showingRoundEdit = false;
    },

    handleModalResultOK() {
      console.log('Action ok-d');
      this.showingRoundEdit = false;
      this.loadRounds();
    },

    loadRounds: function() {
      let path = '/tournament/' + this.tournamentId + '/round' ;
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.rounds = response;
          console.log("Rounds loaded" + JSON.stringify(that.rounds));
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadScores: function() { 
      const myInit = { 
        response: false
      };
      let completePath = '/score?absentOnly=true&tournamentId=' + this.$route.params.tournamentId;
      let that = this;
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.absenceScores = response;
          that.absentWithMSG = that.absenceScores.find(r => { 
          if (r.name === 'absent with message') { 
            return r
          }});
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("Error", JSON.stringify(error));
          }
        });
    },

    loadUserAbsences() {
      let path = '/absence?tournamentId=' + this.tournamentId + '&personId=' + this.$CAUser.getPersonId();
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.userAbsences = response;
          console.log("absences: " + JSON.stringify(response));
          that.loadRounds();
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    loadUserResults() {
      let path = '/match?tournamentId=' + this.tournamentId + '&personId=' + this.$CAUser.getPersonId();
      let that = this
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          that.userResults = response;
          console.log("User Results" + JSON.stringify(that.userResults));
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    pairRound: function(roundId) {
      let path = '/round/' + roundId + '/pair' ;
      console.log("Path  " + path);
      let that = this
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false, 
      };

      RestAPI
        .post(apiName, path, localInit)
        .then(response => {
          //that.rounds = response;
          console.log("Paired " + response);
          //RoundNumber emitten, geen roundId
          //that.$emit("showRound", roundId);
        })
        .catch(error => {
          console.log(error.response);
        });
      console.log("Pairing done" + that.rounds);
    },

    notPresentInRound: function(roundId) {
      var result = "presentInactive";
      var absence = this.userAbsences.find(ua => { 
      if (ua.roundId === roundId) { 
        return ua
      }});
      if (absence != null) {
        if (absence.reasonId == this.absentWithMSG.scoreId)
          result = "notPresent";
      }

      return result;
    },

    presentInRound: function(roundId) {
      var result = "presentInactive";
      var absence = this.userAbsences.find(ua => { 
      if (ua.roundId === roundId) { 
        return ua
      }});
      if (absence == null) {
        result = "present";
      }

      return result;
    },

    removeAbsence(absence) {
      let path = '/absence/' + absence.absenceId;
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false, 
      };
      console.log('Deleting absence: ' + absence.absenceId);
      RestAPI
        .del(apiName, path, localInit)
        .then(response => {
          console.log('Succes.' + response);
        })
        .catch(error => {
          console.log(error.response);
        });        
    },

    showAbsenceForRound: function(roundId) {
      if (this.userAbsences.length > 0) {
        var absence = this.userAbsences.find(ua => { 
        if (ua.roundId === roundId && ua.participant.personId === this.$CAUser.getPersonId()) { 
          return ua
        }});

        if (absence != null) {
          var score = this.absenceScores.filter(item => item.scoreId == absence.reasonId);

          return score[0].name;
        }  
      }
    },

    showDate: function(sDate) {
      return moment(sDate).format("DD MMM yyyy");
    },

    showUserResult: function(roundId) {
      var result = "";
      var matchResult = "";
      var match = this.userResults.find(ur => { 
      if (ur.roundId === roundId) { 
        return ur
      }});
      if (match != null) {
        switch (match.result) {
          case 0:
            matchResult = "";
            break;
          case 1:
            matchResult = "1-0";
            break;
          case 2:
            matchResult = "0-1";
            break;
          case 3:
            matchResult = "&frac12;-&frac12;";
            break;
        }
        result = match.whitePlayer.person.name + " - " + match.blackPlayer.person.name + " "  + matchResult;
      }
      return result;
    }

  }
}
</script>

<style scoped>

.pushup-one {
  padding-bottom: 1px;
}

.pushup-two {
  padding-bottom: 2px;
}

.two-column-container {
  display: grid;
  grid-template-columns: 1fr 1fr; 
  gap: 20px; 
}

.item {
  padding-left: 6px;
}
.column {
  background-color: #2a2a2a;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 20px;
  width: 100%;
  margin-bottom: 20px;
}

.wide {
  width: 100%;
}

.imgbtn {
  text-align: right;
  border: 1px solid #333333;
  border-radius: 2px;
}

.actionButton {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  width: 30px;
}

.present {
  background-color: green;
  color: white;
  border-radius: 2px;
  float: left;
  width: 34px;
  height: 20px;
  text-align: center;
}

.presentInactive {
  background-color: inherit;
  border-radius: 2px;
  color: white;
  float: left;
  width: 30px;
  text-align: center;
}

.notPresent {
  background-color: red;
  color: white;
  border-radius: 2px;
  float: left;
  width: 30px;
  text-align: center;
}

.yesno {
  float:left;
}
/* mobile */
@media screen and (max-width: 600px) {
  .modal {
    width: 98vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
}

/* laptop */
@media screen and (min-width: 1281px) {

}

</style>
